<div class="modal" id="notificationFormModal" tabindex="-1">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-primary-blue">
          {{ notificationToEdit() ? 'Editar Notificación' : 'Nueva Notificación' }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <form [formGroup]="this.notificationForm" (ngSubmit)="this.onSubmit()">
        <div class="modal-body">

          <div class="mb-3">
            <label class="form-label text-secondary-yellow">Tipo de mensaje</label>
            <div class="btn-group w-100" role="group">
              <input
                type="radio"
                class="btn-check"
                id="html-false"
                autocomplete="off"
                formControlName="html"
                [value]="false"
              />
              <label class="btn btn-outline-secondary" for="html-false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-align-left me-1"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 6l16 0" />
                  <path d="M4 12l10 0" />
                  <path d="M4 18l14 0" />
                </svg>
                Texto plano
              </label>

              <input
                type="radio"
                class="btn-check"
                id="html-true"
                autocomplete="off"
                formControlName="html"
                [value]="true"
              />
              <label class="btn btn-outline-secondary" for="html-true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-code me-1"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 8l-4 4l4 4" />
                  <path d="M17 8l4 4l-4 4" />
                  <path d="M14 4l-4 16" />
                </svg>
                HTML
              </label>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label text-secondary-yellow">Mensaje</label>
            <textarea
              class="form-control font-monospace"
              name="mensaje"
              placeholder="Ingresa el mensaje de la notificación"
              formControlName="mensaje"
              rows="8"
            ></textarea>
          </div>

          @if (notificationForm.get('html')?.value === true) {
            <div class="mb-3">
              <label class="form-label text-muted">Previsualización</label>
              <div
                class="border rounded p-3 bg-white"
                style="min-height: 100px;"
                [innerHTML]="safeHtml()"
              ></div>
            </div>
          }

        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-link link-secondary"
            data-bs-dismiss="modal"
          >
            Cancelar
          </button>
          <button
            [disabled]="this.notificationForm.invalid"
            type="submit"
            class="btn btn-primary ms-auto"
            data-bs-dismiss="modal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler"
              [class.icon-tabler-plus]="!notificationToEdit()"
              [class.icon-tabler-edit]="notificationToEdit()"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              @if (!notificationToEdit()) {
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M12 5l0 14"></path>
                <path d="M5 12l14 0"></path>
              } @else {
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"></path>
                <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"></path>
                <path d="M16 5l3 3"></path>
              }
            </svg>
            {{ notificationToEdit() ? 'Actualizar Notificación' : 'Registrar Notificación' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>